"use client";
import "../chunk-GOCCUU3Z.js";
const getDeviceModelName = (model) => {
  if (!model) {
    return void 0;
  }
  switch (model.toLowerCase()) {
    case "macintosh": {
      return "Mac";
    }
    case "k": {
      return "Android";
    }
    default: {
      return model;
    }
  }
};
export {
  getDeviceModelName
};
